module.exports = __webpack_public_path__ + "img/cursor.2bde45f.png";